export default "/images/993c1491d1d3a7b171807e6d4af8df5d.avif";